// GuidesVisualizerView.js
import React from "react";

const GuidesVisualizerView = ({ tutorial }) => (
  <div className="h-100 d-flex flex-column align-items-center justify-content-center bg-light p-4">
    <div className="ratio ratio-16x9 w-100 rounded shadow-sm bg-dark">
      <iframe
        src={tutorial.media}
        title={tutorial.name}
        className="rounded"
        allowFullScreen
      />
    </div>

    <p className="mt-3 text-center text-muted">
      {tutorial.description}
    </p>
  </div>
);

export default GuidesVisualizerView;
